import Vue from 'vue';
import VTooltip from 'v-tooltip'


import { ValidationMessages } from "@/services/validator/localization";
import { Validator } from "vee-validate";
import VeeValidate from "vee-validate";

import $ from 'jquery';
import projectPage from "@/components/project-page/project-page.vue";
import category from '@/components/category/category.vue';
import nomineeMainPage from "@/components/nominee-main-page/nominee-main-page.vue";
import winnersMainPage from "@/components/winners-main-page/winners-main-page.vue";
import {getEnableWinnerCarousel} from "@/services/getWinnerData/getWinnerData";
import winnersCarouselBlock from "@/components/winners-carousel-block/winners-carousel-block.vue";

Vue.config.productionTip = false;

Validator.localize({ en: ValidationMessages.en });
Vue.use(VeeValidate, { locale: "en" });
Vue.use(VTooltip);


Vue.component('category', require('./components/category/category.vue').default);
$('body .wrapper').append('<div class="tour" id="tour"></div>');

declare let isCategoryPage;
declare let year;
export const getYear = ()  => {
    if ( year ) {
        return year;
    }
    return '';
}
export const getIsCategoryPage = () => {
    if (typeof isCategoryPage != "undefined")
        return isCategoryPage;
    return false;
};
declare let isNomineePage;
export const getIsNomineePage = () => {
    if (typeof isNomineePage != "undefined")
        return isNomineePage;
    return false;
};
declare let isWinnersPage;
export const getIsWinnersPage = () => {
    if (typeof isWinnersPage != "undefined")
        return isWinnersPage;
    return false;
};
if(getIsCategoryPage()){
    new Vue({
        render(h) {
            return h(category, { props: {
                year : getYear()
            } });
        },
        methods: {}
    }).$mount('#lc-app');
}else if(getIsNomineePage()){
    new Vue({
        render(h) {
            return h(nomineeMainPage, { props: {} });
        },
        methods: {
        }
    }).$mount('#lc-app-nominee');
}else if(getIsWinnersPage()){
    new Vue({
        render(h) {
            return h(winnersMainPage, { props: {} });
        },
        methods: {
        }
    }).$mount('#lc-app-winners');
}else{
    new Vue({
        render(h) {
            return h(projectPage, { props: {
                year : getYear()
            } });
        },
        methods: {}
    }).$mount('#lc-app-project');
}

if(getEnableWinnerCarousel()){
    new Vue({
        render(h) {
            return h(winnersCarouselBlock, { props: {} });
        },
        methods: {
        }
    }).$mount('#lc-app-carousel');
}



